import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHighlight]',
})
export class HighlightDirective implements OnChanges {
  @Input() appHighlight: string = '';
  @Input() searchText: string = '';
  @Input() caseSensitive: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchText'] || changes['appHighlight']) {
      this.highlight();
    }
  }

  private highlight(): void {
    if (!this.searchText || !this.appHighlight) {
      this.el.nativeElement.innerHTML = this.appHighlight;
      return;
    }

    const text = this.appHighlight;
    const searchValue = this.searchText;

    if (!searchValue) {
      this.el.nativeElement.innerHTML = text;
      return;
    }

    const regex = new RegExp(
      this.escapeRegExp(searchValue),
      this.caseSensitive ? 'g' : 'gi'
    );

    const highlightedText = text.replace(
      regex,
      match => `<span class="highlight">${match}</span>`
    );

    this.el.nativeElement.innerHTML = highlightedText;
  }

  private escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
